/**
 * ChannelBadge (TASK-208)
 *
 * Renders a colored badge with an icon for a message channel
 * (web / telegram / voice / email / max).
 */
import { Globe, Send, Mic, Mail, MessageCircle } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { MessageSource } from '@/services/api/dashboard'

interface ChannelConfig {
  label: string
  icon: typeof Globe
  className: string
}

const CHANNEL_CONFIG: Record<MessageSource, ChannelConfig> = {
  web: {
    label: 'Web',
    icon: Globe,
    className: 'bg-blue-100 text-blue-800',
  },
  telegram: {
    label: 'Telegram',
    icon: Send,
    className: 'bg-sky-100 text-sky-800',
  },
  voice: {
    label: 'Голос',
    icon: Mic,
    className: 'bg-purple-100 text-purple-800',
  },
  email: {
    label: 'Почта',
    icon: Mail,
    className: 'bg-amber-100 text-amber-800',
  },
  // KAN-931: MAX messenger.
  max: {
    label: 'MAX',
    icon: MessageCircle,
    className: 'bg-indigo-100 text-indigo-800',
  },
}
interface ChannelBadgeProps {
  source: string
  className?: string
}

export function ChannelBadge({ source, className }: ChannelBadgeProps) {
  const config =
    CHANNEL_CONFIG[source as MessageSource] ?? CHANNEL_CONFIG.web
  const Icon = config.icon
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        config.className,
        className
      )}
    >
      <Icon className="h-3 w-3" />
      {config.label}
    </span>
  )
}
